'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
let app = typeof window !== 'undefined' ? window.app : undefined;
export default class Link extends PureComponent {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const is_link = props.href ? true : false;
    const {
      className,
      href,
      'dom-ref': ref,
      ...herited
    } = props;
    if (is_link && props.href !== document.location.pathname) {
      const output = /*#__PURE__*/React.createElement(RouterLink, _extends({}, herited, {
        to: href,
        className: className,
        onClick: app.resetFunctions,
        ref: ref
      }), props.children);
      return output;
    }
    const output = /*#__PURE__*/React.createElement("span", _extends({}, herited, {
      className: className,
      ref: ref
    }), props.children);
    return output;
  }
}
Link.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string
};
